// utils
import normalizer from 'Shared/utils/normalizeJSON/normalizer';
import WpToastManager from 'Wpds/components/toast/WpToastManager';

// Constants
import AiSuggestionWorkspaceItemsConstants from 'Shared/constants/AiSuggestionWorkspaceItems.constants';

// API
import * as api from '../api/AiSuggestionWorkspaceItems.api';

// Schema
import AiSuggestionWorkspaceItem from 'Shared/utils/normalizeJSON/schemas/AiSuggestionWorkspaceItem.schema';

export const createNewAiSuggestionWorkspaceeItemsSuccess = payload => ({
  type: AiSuggestionWorkspaceItemsConstants.Actions.CREATE_NEW_AI_SUGGESTIONS_WORKSPACE_ITEMS_SUCCESS,
  payload,
});

export const fetchAiSuggestionWorkspaeItems = ({ workspaceId }) => {
  return api.fetchAiSuggestionWorkspaceItems({ workspaceId }).then(response => {
    const normalizedData = normalizer(AiSuggestionWorkspaceItem, response.data.ai_suggestion_workspace_items);
    return { normalizedData, response };
  });
};

export const createNewAiSuggestionWorkspaceeItems = ({ workspaceId }) => dispatch => {
  return api.createNewAiSuggestionWorkspaceeItems({ workspaceId }).then(response => {
    dispatch(createNewAiSuggestionWorkspaceeItemsSuccess({ workspaceId }));
    return response;
  });
};

export const createNewAiSuggestionWorkspaceeItemsPoll = ({ workspaceId }) => {
  return api
    .createNewAiSuggestionWorkspaceeItemsPoll({ workspaceId })
    .then(response => {
      const normalizedData = normalizer(AiSuggestionWorkspaceItem, response?.data?.ai_suggestion_workspace_items || []);
      return { normalizedData, response };
    })
    .catch(error => {
      WpToastManager.danger('An error occurred. Please try again.');
      return error;
    });
};

export const acceptAiSuggestionWorkspaceItem = ({ workspaceId, aiSuggestionWorkspaceItemSlug }) => {
  return api.acceptAiSuggestionWorkspaceItem({ workspaceId, aiSuggestionWorkspaceItemSlug }).then(response => {
    return response;
  });
};

export const rejectAiSuggestionWorkspaceItem = ({ workspaceId, aiSuggestionWorkspaceItemSlug }) => {
  return api.rejectAiSuggestionWorkspaceItem({ workspaceId, aiSuggestionWorkspaceItemSlug }).then(response => {
    return response;
  });
};
